// PR 46 review · Part 3 (D2, D4, D5, D6): Audit Trail labels of the adjusting-entry new accounts (aje_new_accounts.py,
// adjusting_entries_routes.py) and of the per-account cash-flow settings (cash_flow_settings.py), and the new refusal code,
// EN + AR. Merged into lib/i18n.js translations (big-file rule: new strings in their own file).
export const I18N_PR46R_D = {
  en: {
    w13: {
      action: {
        aje_account_added: "Account added for an adjusting entry",
        aje_account_updated: "Account for an adjusting entry edited",
        aje_account_added_to_chart: "Account added to the chart of accounts (posted adjusting entry)",
        aje_account_removed_from_chart: "Account removed from the chart of accounts (voided adjusting entry)",
        coa_cf_settings_changed: "Cash-flow settings of an account changed",
      },
      entity: { aje_added_account: "Account added for an adjusting entry" },
    },
    errors: {
      AJE_NEW_ACCOUNT_NOTE_FS_MISMATCH: "The note mapping belongs to another FS line — pick a note of the account's FS mapping.",
    },
  },
  ar: {
    w13: {
      action: {
        aje_account_added: "إضافة حساب لقيد تسوية",
        aje_account_updated: "تعديل حساب لقيد تسوية",
        aje_account_added_to_chart: "إضافة حساب إلى دليل الحسابات (قيد تسوية مُرحَّل)",
        aje_account_removed_from_chart: "إزالة حساب من دليل الحسابات (قيد تسوية مُلغى)",
        coa_cf_settings_changed: "تغيير إعدادات التدفقات النقدية لحساب",
      },
      entity: { aje_added_account: "حساب مضاف لقيد تسوية" },
    },
    errors: {
      AJE_NEW_ACCOUNT_NOTE_FS_MISMATCH: "ربط الإيضاح يتبع بندًا آخر في القوائم المالية — اختر إيضاحًا من ربط القوائم المالية للحساب.",
    },
  },
};

export default I18N_PR46R_D;
